import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';


import {colors} from  '../colors/colors.js'; 
import { Edit, LocationDisabledOutlined, MyLocation } from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import { RestartAlt } from '@mui/icons-material';

import {
  isGeopoint
  } from '../hooks/geo-location'; 

/**
 *  ref 
 * https://www.npmjs.com/package/react-google-autocomplete
 * 
 * https://developers.google.com/maps/documentation/javascript/examples/map-geolocation
 * 
 */
const useStyles = makeStyles((theme) => ({

   geopointSection:{
    display: 'flex',
    flexDirection:'row',
    justifyContent: 'space-between',
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    //backgroundColor: 'blue',
    paddingLeft: "0.3rem",
    paddingRight:  "0.5rem"
   },

   geopointRow: {
    display: 'flex', 
    justifyContent: 'flex-start',
    alignItems:'center',
    width: "100%",
    border: "none",
    borderRadius: "0.5rem",
    placeHolder:"Address",
    backgroundColor: colors.grayBackground,
     
    marginRight:"0.5rem",
    paddingLeft:"0.3rem",
    paddingRight:"0.5rem",
    minHeight: "2rem"
    //backgroundColor:'red' 
  }, 

   geopointInput:{
    marginLeft:"0.5rem",
    outline:'none', 
    fontSize: '0.95rem',
   //colors.grayBackground
   //backgroundColor:'red' 
  },

  geopointButton: {
 
   },

}));



export default function GeopointInput(props) {
 
  const classes = useStyles();

  const { 
      onClickInput,
      geopoint, 
      editing,
      hintEmpty,
      onAction
    } = props; 

   const getStrGeopoint =(geopoint)=>{
     return `(${geopoint.latitude.toFixed(5)},${geopoint.longitude.toFixed(5)})`
   }



   //console.debug("GeopointInput", geopoint);
  return (
    
      
        <div className={classes.geopointSection}>
        {  !editing && 
          <div className={classes.geopointRow}> 
            {
            isGeopoint(geopoint) ? <MyLocation color='accent'/> : <LocationDisabledOutlined color ='disabled'/>    
            }
            <div className={classes.geopointInput}>
            <Typography className={classes.geopointText}>{isGeopoint(geopoint) ? `${getStrGeopoint(geopoint)}`: hintEmpty}</Typography>
            </div>           
          </div>
         }  

        { !editing && 
         <Button
          variant="contained"
          color="accent"
          size = 'small'
          onClick = {onAction}   
          disabled={!isGeopoint(geopoint)} 
          className={classes.geopointButton }        
          >
          <Edit/>
          </Button>
          }


        {  editing && 
          <div className={classes.geopointRow}> 
            {
            isGeopoint(geopoint) ? <MyLocation color='alert'/> : <LocationDisabledOutlined color ='disabled'/>    
            }
            <div className={classes.geopointInput}>
            <Typography className={classes.geopointText}>{isGeopoint(geopoint) ? `${getStrGeopoint(geopoint)}`: hintEmpty}</Typography>
            </div>           
          </div>
         }

          {  editing && 
         <Button
          variant="contained"
          color="alert"
          size = 'small'
          onClick = {onAction}   
          disabled={!isGeopoint(geopoint)} 
          className={classes.geopointButton }        
          >
            <RestartAlt/>
          </Button>
          }

        </div>   
  
  );
}